import React from 'react';
import {createPortal} from 'react-dom';
import {Title, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import texts from '../../../../texts';
import img from './../../../../../../images/loaderQuiz.png';

const Loader = () => {
    return (
        <div className={styles.component}>
            <div className={styles.loaderWrap}>
                <img src={img} alt="Priority Loader" />
                <Title componentClasses={styles.title} skin="h2" textColor="primary-700">
                    {texts.quiz_loader_title}
                </Title>
                <Text
                    componentClasses={styles.text}
                    skin="paragraph-1"
                    tag="p"
                    textColor="primary-700"
                >
                    {texts.quiz_loader_text}
                </Text>
            </div>
        </div>
    );
};

export const LottieLoader = () =>
    createPortal(<Loader />, document.getElementById('onboarding-content'));
